import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_FOLLOW_PROFILES').plugin(axiosPlugin, {template: "array"});

let fetchFollowProfilesAction = redux.fetchActionGet();

export const fetchFollowProfiles = (query = {}) => fetchFollowProfilesAction(`/features/users-follows?${queryString.stringify(query)}`);

export const homeFollowProfiles = redux.reducer();